import React, { useEffect } from "react";
import styles from "./activation.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";

function Activation() {
  const navigate = useNavigate();
  
  const sampleDataGenerated = useSelector((state) =>
    _.get(state, "users.activation.sampleDataGenerated"),
  );

  useEffect(() => {
    setTimeout(() => {
      navigate("/hub");
    }, 30000);
  }, []);
  
  useEffect(() => {
    if(sampleDataGenerated){
      navigate("/hub");
    }
  }, [sampleDataGenerated]);

  return (
    <div className={styles.activationContainer}>
      Activating account. Please refresh in sometime.
    </div>
  )
}

export default Activation;
